import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import DefaultFooter from "components/Footers/DefaultFooter";
import { Container, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import Breadcrums from "components/Breadcrumbs";
import MKTypography from "components/MKTypography";
import IframeResizer from "iframe-resizer-react";

function CommercialValue() {
  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <MKBox component="section" bgColor="white" py={4}>
        <Container>
          <Grid container spacing={1} item xs={12} lg={12} mx="auto">
            <Grid item xs={4}>
              <Breadcrums
                routes={[
                  { label: "Inicio", route: "/" },
                  { label: "Actividades Económicas Urbanas", route: "#" },
                  { label: "Precio de los Bienes Inmuebles", route: "#" },
                ]}
              />
            </Grid>
          </Grid>
        </Container>
      </MKBox>
      <MKBox width="100%">
        <Container>
          <MKBox p={1} position="relative">
            <MKTypography variant="h1">Precio de los Bienes Inmuebles</MKTypography>
          </MKBox>
          <br />
          <IframeResizer
            heightCalculationMethod="lowestElement"
            inPageLinks
            log
            autoResize
            src="https://datastudio.google.com/embed/reporting/24b1be85-7758-4f2b-b1aa-503f673ec50b/page/rfbuC"
            style={{ width: "100%", height: "960px", border: 0 }}
          />
          <br />
        </Container>
        <br />
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default CommercialValue;
